import {Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {Location} from '@angular/common';

@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss'],
    standalone: false
})
export class PageTitleComponent implements OnInit {

  @Input() title: string;
  @Input() useRouterButton = false;
  @Input() isBoldedTitle = false;
  @Input() routerUrl: string;
  @Input() subTitle: string;

  @ContentChild(TemplateRef, {static : true}) topMenu: TemplateRef<any>;

  constructor(
    private location: Location
  ) {
  }

  ngOnInit() {
  }

  goBack() {
    this.location.back();
  }

}
